import React, { useState, useEffect } from 'react';
import { 
  Search, Grid, List, RefreshCw, MapPin, Calendar, TrendingUp,
  Users, Target, CheckCircle, XCircle
} from 'lucide-react';
import './PreSowing.css';

const BootingStage = () => {
  const [viewMode, setViewMode] = useState('grid');
  const [filterStatus, setFilterStatus] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [activities, setActivities] = useState([]);

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetch(" https://sadaatagrofarms.com/api/crop_stages/booting/", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setActivities(data);
        }
      })
      .catch(err => console.error("Booting Fetch Error:", err));
  }, [token]);

  // 🔍 FILTERING  
  const filtered = activities.filter(item => {
    const searchText = searchQuery.toLowerCase();

    const matchesSearch =
      (item.flag_leaf_status || "").toLowerCase().includes(searchText) ||
      (item.spike_status || "").toLowerCase().includes(searchText) ||
      (item.crop_uniformity || "").toLowerCase().includes(searchText);

    const matchesStatus =
      filterStatus === "All" ||
      (filterStatus === "Prepared" && item.flag_leaf_status > 40) ||
      (filterStatus === "Not Prepared" && item.flag_leaf_status <= 40);

    return matchesSearch && matchesStatus;
  });

  return (
    <div className="pre-sowing">

      <div className="stage-tabs">
        <button className="stage-tab">Pre-Sowing</button>
        <button className="stage-tab">Sowing & Emergence</button>
        <button className="stage-tab">Emergence</button>
        <button className="stage-tab">Growth & Tillering</button>
        <button className="stage-tab active">Booting Stage</button>
      </div>

      <div className="page-header">
        <div>
          <h1>Booting Stage Monitoring</h1>
          <p className="subtitle">Crop growth indicators from the booting stage</p>
        </div>

        <button className="refresh-btn" onClick={() => window.location.reload()}>
          <RefreshCw size={16} />
          Refresh Data
        </button>
      </div>

      {/* Search & Filters */}
      <div className="controls-section">

        <div className="search-box">
          <Search size={18} />
          <input
            type="text"
            placeholder="Search flag leaf, spike status, uniformity..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="view-toggle">
          <button
            className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => setViewMode('grid')}
          >
            <Grid size={18} />
          </button>

          <button
            className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
            onClick={() => setViewMode('list')}
          >
            <List size={18} />
          </button>
        </div>

        <div className="status-filters">
          <button
            className={`filter-chip ${filterStatus === 'All' ? 'active' : ''}`}
            onClick={() => setFilterStatus('All')}
          >
            All
          </button>

          <button
            className={`filter-chip ${filterStatus === 'Prepared' ? 'active' : ''}`}
            onClick={() => setFilterStatus('Prepared')}
          >
            Prepared
          </button>

          <button
            className={`filter-chip ${filterStatus === 'Not Prepared' ? 'active' : ''}`}
            onClick={() => setFilterStatus('Not Prepared')}
          >
            Not Prepared
          </button>
        </div>
      </div>

      {/* Count */}
      <div className="results-bar">
        Showing <strong>{filtered.length}</strong> results
      </div>

      {/* GRID */}
      <div className={`activities-${viewMode}`}>
        {filtered.map((item) => (
          <div key={item.id} className="activity-card">

            <div className="activity-header">
              <div className="activity-crop">
                <span className="crop-icon">🌾</span>
                <span className="crop-name">Booting</span>
              </div>

              <span className="status-badge prepared">
                Stage Active
              </span>
            </div>

            <div className="activity-location">
              <MapPin size={14} />
              <span>Farmer ID: {item.farmer} • Farm ID: {item.farm}</span>
            </div>

            <div className="activity-type">Booting Stage Indicators</div>

            <div className="activity-details">
              <div className="detail-row">
                <span className="detail-label">Flag Leaf</span>
                <span className="detail-value">{item.flag_leaf_status}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Soil Moisture</span>
                <span className="detail-value">{item.soil_moisture_condition}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Spike Status</span>
                <span className="detail-value">{item.spike_status}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Uniformity</span>
                <span className="detail-value">{item.crop_uniformity}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Weeds</span>
                <span className="detail-value">{item.weeds_in_field}</span>
              </div>
            </div>

            <div className="activity-footer">
              <div className="activity-date">
                <Calendar size={14} />
                <span>Stage Recorded</span>
                <strong>Booting Stage</strong>
              </div>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default BootingStage;
